import { getError } from "@/utils/helpers";
import FAQAccordionService from "@/services/FAQAccordionService";

export const namespaced = true;

function setFields(commit, response) {
  commit("SET_FIELD", response.data);
  commit("SET_LOADING", false);
}

export const state = {
  accordion: [],
  loading: false,
  error: null,
};

export const mutations = {
  SET_FIELD(state, accordion) {
    state.accordion = accordion;
  },
  SET_LOADING(state, loading) {
    state.loading = loading;
  },
  SET_ERROR(state, error) {
    state.error = error;
  },
};

export const actions = {
  getField({ commit }) {
    commit("SET_LOADING", true);
    FAQAccordionService.getField()
      .then((response) => {
        setFields(commit, response);
      })
      .catch((error) => {
        commit("SET_LOADING", false);
        commit("SET_ERROR", getError(error));
      });
  },
};

export const getters = {
  accordion: (state) => {
    return state.accordion;
  },
  loading: (state) => {
    return state.loading;
  },
  error: (state) => {
    return state.error;
  },
};
